module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "margin": "4px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Finalizar Devolução\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('entity-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Cliente",
      "usingAsProvider": "/customers",
      "usingAsLabel": "name",
      "usingAsValue": "id",
      "orderBy": "name",
      "icon": "user",
      "wrapperClass": "col-lg-6",
      "placeholder": "Selecione o Cliente",
      "name": "customer_id",
      "custom-error": _vm.errors.first('customer_id'),
      "valid": _vm.fields.valid('customer_id'),
      "failed": _vm.fields.failed('customer_id')
    },
    model: {
      value: (_vm.customer_id),
      callback: function($$v) {
        _vm.customer_id = $$v
      },
      expression: "customer_id"
    }
  }), _vm._v(" "), _c('entity-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Veículo",
      "usingAsProvider": '/entries-by-tenant/' + _vm.currentTenant + '?only-available=true' + '&q=consigned:1;state_id:1&sf=consigned:=;state_id:=&_and=true',
      "usingAsLabel": "fipe_vehicle_renavam_plate",
      "usingAsValue": "id_key",
      "orderBy": "fipe_vehicle",
      "icon": "car",
      "wrapperClass": "col-lg-6",
      "placeholder": "Selecione o Veículo",
      "name": "entry_id",
      "custom-error": _vm.errors.first('entry_id'),
      "valid": _vm.fields.valid('entry_id'),
      "failed": _vm.fields.failed('entry_id')
    },
    model: {
      value: (_vm.entry_id),
      callback: function($$v) {
        _vm.entry_id = $$v
      },
      expression: "entry_id"
    }
  })], 1), _vm._v(" "), (_vm.expenses.length) ? _c('fieldset', [_c('legend', [_vm._v("Despesas")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.expenses), function(expense, index) {
    return _c('tr', {
      class: {
        'bg-success': expense.paid, 'bg-danger': !expense.paid
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.expense_type.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(expense.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.paid ? 'SIM' : 'NÃO'))])])
  }), 0)])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-info-circle"
  }), _vm._v("\n            Despesas do veículo "), _c('b', [_vm._v("marcadas como paga")]), _vm._v(", serão lançados como "), _c('b', [_vm._v("despesas não pagas")]), _vm._v(" na conta do cliente\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-info-circle"
  }), _vm._v("\n            O veículo será marcado como indisponível automaticamente\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    DESPESAS DO VEÍCULO\n                  ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Pago")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-475810e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Edit/ReturnForm.vue
// module id = 1006
// module chunks = 1